import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { FieldWrap } from "@/components/Field";
import { api, errMsg } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { setError("Password must be at least 6 characters"); return; }
    if (pw !== pw2) { setError("The two passwords do not match"); return; }
    setBusy(true); setError("");
    try { await api.post("/auth/reset-password", { token, new_password: pw }); toast.success("Password changed. Please sign in."); nav("/login", { replace: true }); }
    catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <div className="site-bg flex min-h-screen items-center justify-center bg-background px-6 py-12">
      <form onSubmit={submit} className="w-full max-w-sm space-y-5 rounded-2xl bg-white p-8 shadow-xl" data-testid="reset-password-form">
        <h1 className="font-heading text-3xl font-bold text-slate-900">Choose a new password</h1>
        {!token ? <p className="text-sm text-red-700" data-testid="reset-password-missing">This link is missing its code. Please ask for a new reset email.</p> : (
          <>
            <FieldWrap label="New password (6+ characters)"><Input type="password" autoComplete="new-password" className="h-12 bg-white" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password-new" /></FieldWrap>
            <FieldWrap label="Type it again"><Input type="password" autoComplete="new-password" className="h-12 bg-white" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="reset-password-confirm" /></FieldWrap>
            {error && <div className="rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-800" data-testid="reset-password-error">{error}</div>}
            <Button type="submit" disabled={busy} className="h-12 w-full" data-testid="reset-password-submit">Save new password</Button>
          </>
        )}
        <Link to="/login" className="block text-center text-sm font-semibold text-[hsl(var(--primary))] hover:underline" data-testid="reset-password-back">Back to sign in</Link>
      </form>
    </div>
  );
}
